import axios from "axios";

// Reutiliza la base de la URL API de tu entorno
const API_BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");

export async function obtenerFacturasActivas() {
  const empresaId = Number(localStorage.getItem("empresaId") || 0);
  const response = await axios.get(`${API_BASE}/api/facturas/activas`, {
    params: { empresaId },
  });
  return response.data;
}

/* =========================================================================
   Obtiene el Detalle de una Factura
========================================================================= */

/**
 * Obtiene el detalle completo de una factura (cabecera y partidas) desde el backend.
 * * @param {object} params - Parámetros de búsqueda.
 * @param {string} params.serie - La serie de la factura (e.g., 'A').
 * @param {number} params.factura - El número de documento de la factura (e.g., 5079).
 * @param {number} params.empresa - El ID de la empresa (e.g., 1).
 * @returns {Promise<object>} El objeto FacturaDetalleRespuestaDto del backend.
 */
export async function obtenerDetalleFactura({ serie, factura, empresa }) {
  // La URL debe apuntar al endpoint que creaste en el controlador:
  // GET: /api/facturas/Detalle?serie=A&factura=123&empresa=1
  const API_URL = `${API_BASE}/api/facturas/Detalle`;

  if (!serie || !factura || !empresa) {
    throw new Error(
      "Faltan parámetros: serie, factura y empresa son obligatorios."
    );
  }

  try {
    const response = await axios.get(API_URL, {
      params: {
        serie: serie,
        factura: factura,
        empresa: empresa,
      },
    });

    // La respuesta del backend es el DTO que creaste (FacturaDetalleRespuestaDto)
    return response.data;
  } catch (e) {
    if (axios.isAxiosError(e)) {
      // Manejo de errores específicos de Axios (404, 500, etc.)
      console.error(
        "Error al obtener detalle de factura (Axios):",
        e.response?.data || e.message
      );

      if (e.response?.status === 404) {
        throw new Error("Factura no encontrada (Error 404).");
      }
      // Puedes lanzar un error más específico para la UI
      throw new Error(
        `Error al cargar el detalle de la factura: ${
          e.response?.statusText || e.message
        }`
      );
    }

    console.error("Error desconocido al obtener detalle de factura:", e);
    throw e;
  }
}

export async function obtenerSiguienteFolio(serie = "A") {
  const response = await axios.get(`${API_BASE}/api/facturas/siguiente-folio`, {
    params: { serie },
  });
  return response.data;
}

export async function crearFactura(payload) {
  const response = await axios.post(`${API_BASE}/api/facturas/crear`, payload);
  return response.data;
}

export async function actualizarFactura(payload) {
  const response = await axios.put(`${API_BASE}/api/facturas/actualizar`, payload);
  return response.data;
}

export async function timbrarFactura({ serie, factura, empresa }) {
  const response = await axios.post(`${API_BASE}/api/facturas/timbrar`, { serie, factura, empresa });
  return response.data;
}

export async function cancelarFactura({ serie, factura, empresa, motivo, folioSustitucion }) {
  const response = await axios.post(`${API_BASE}/api/facturas/cancelar`, { serie, factura, empresa, motivo, folioSustitucion });
  return response.data;
}

export async function enviarCorreoFactura({ serie, factura, empresa, destinatario, asunto, cuerpo, archivos = [] }) {
  const fd = new FormData();
  fd.append("serie", serie);
  fd.append("factura", factura);
  fd.append("empresa", empresa);
  fd.append("destinatario", destinatario);
  fd.append("asunto", asunto);
  fd.append("cuerpo", cuerpo);
  for (const archivo of archivos) fd.append("adjuntos", archivo);

  const response = await axios.post(`${API_BASE}/api/facturas/enviar-correo`, fd);
  return response.data;
}

export async function obtenerXMLFactura({ serie, factura, empresa }) {
  const url = `${API_BASE}/api/facturas/xml?serie=${encodeURIComponent(serie)}&factura=${encodeURIComponent(factura)}&empresa=${encodeURIComponent(empresa)}`;
  try {
    const response = await axios.get(url, { responseType: "text" });
    return response.data;
  } catch (e) {
    const status = e.response?.status;
    if (status === 404) throw new Error("XML no encontrado en CFDI_Comprobantes (404)");
    if (status === 500) throw new Error(`Error en el servidor (500): ${e.response?.data || e.message}`);
    if (!status) throw new Error(`No se pudo conectar al servidor: ${e.message}`);
    throw new Error(`Error HTTP ${status}: ${e.message}`);
  }
}
